import { FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import JobsSearchSuggestedTags from 'models/JobsSearchSuggestedTags';

import saveIcon from 'theme/icons/saveCheck.svg';

import Button, { ButtonIconPositions, ButtonIconTypes, ButtonStyles, ButtonVariants } from 'components/layout/Button';
import Checkbox from 'components/layout/forms/Checkbox';
import LayoutContainer from 'components/layout/LayoutContainer';
import SearchForm from 'components/modules/public/layout/forms/SearchForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageOffersSectionList: FunctionComponent<Props> = ({
    header,
    footer,
    onSaveJobSearchQuery,
    metaCity,
    jobsList,
    onSuggest,
    suggestedTagsTitle,
    jobsEmptyResultInfo,
    additionalCheckbox,
    setAdditionalCheckbox,
    ...props
}) => {
    const [expand, setExpand]: [boolean, Function] = useState(false);

    const values = {};

    const suggestedTags: JobsSearchSuggestedTags[] = jobsList?.additionalElements?.length > 0 ? jobsList?.additionalElements : null;
    const jobsIsLoading = jobsList?.isLoading;
    const jobs = jobsList?.elements?.length > 0;

    return (
        <StyledComponent className="public-page-offers-section-list">
            <LayoutContainer>
                {header && (
                    <div className="header">
                        <div className="top">
                            { metaCity ? (
                                <h1
                                    className="headline"
                                    dangerouslySetInnerHTML={{ __html: metaCity?.seoTitle }}
                                />
                            ) : (
                                <h1
                                    className="headline"
                                    dangerouslySetInnerHTML={{ __html: header?.headline }}
                                />
                            )}
                            <Button
                                className="header-button"
                                style={ButtonStyles.Secondary}
                                variant={ButtonVariants.Outline}
                                onClick={() => setExpand(!expand)}
                                icon={{
                                    value: expand ? '/images/jobs/arrow-top.svg' : '/images/jobs/arrow-bottom.svg',
                                    hover: expand ? '/images/jobs/arrow-top.svg' : '/images/jobs/arrow-bottom.svg',
                                    position: ButtonIconPositions.After,
                                    type: ButtonIconTypes.Image,
                                    width: 24,
                                    height: 24,
                                }}
                                {...header?.buttonProps}
                            />
                        </div>
                        {expand && (metaCity ? (
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: metaCity?.seoDescription }}
                            />
                        ): (
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: header?.description }}
                            />
                        ))}
                    </div>
                )}
                <SearchForm {...props} />
                {footer && (
                    <>
                        {jobs && (
                            <div className="additional-checkbox-wrapper">
                                <Checkbox
                                    name="additionalCheckbox"
                                    label={footer?.additionalCheckbox?.label}
                                    onChange={() => {
                                        if (! additionalCheckbox) {
                                            onSaveJobSearchQuery();
                                        } else {
                                            setAdditionalCheckbox(false);
                                        }
                                    }}
                                    value={additionalCheckbox}
                                />

                                {
                                    additionalCheckbox && (
                                        <div
                                            className="additional-checkbox-wrapper-save-info"
                                        >
                                            <img
                                                className="icon"
                                                src={saveIcon}
                                                alt=""
                                                loading="lazy"
                                            />
                                            <p
                                                className="info"
                                            >
                                        Zapisano
                                            </p>
                                        </div>
                                    )
                                }
                            </div>
                        )}

                        { suggestedTags && (
                            <div className='jobs-search-suggested-tags'>
                                <h3 className="suggested-title">{suggestedTagsTitle}</h3>
                                <p className="suggested-tags">
                                    {suggestedTags.map(({ id, name, probability }) => (
                                        <Button
                                            key={id}
                                            style={ButtonStyles.None}
                                            className={classnames('suggested-tag', `level-${probability}`)}
                                            onClick={() => onSuggest(name) }
                                        >
                                            {name}
                                        </Button>
                                    ))}
                                </p>
                            </div>
                        )}

                       {/*  { jobsList?.elements?.length === 0 && !suggestedTags && !jobsIsLoading && (
                            <div className='jobs-search-empty-result'>
                                <h3 className="empty-title">{jobsEmptyResultInfo}</h3>
                            </div>
                        )} */}
                    </>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageOffersSectionList;